import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import toast from 'helpers/toast';
import usePublicApi from 'public-api';
import { getFieldErrors, isResponse } from 'public-api/utils';
import authRoutes from 'routes/codegen/authRoutes';
import { useAsyncFunction } from 'stores/hooks';
import AuthCard from 'ui-brand/components/AuthCard';
import Button from 'ui-brand/components/Button';
import { EmailIcon } from 'ui-brand/components/icons';
import TextInput from 'ui-brand/components/TextInput';

function PasswordReset() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | undefined>();
  const [isSent, setIsSent] = useState(false);
  const publicApi = usePublicApi();
  const loginUrl = authRoutes.authLogin({ lang: window.appState.lang });

  const send = async () => {
    setError(undefined);
    try {
      await publicApi.AuthPasswordResetApi.create({ request: { email } });
      setIsSent(true);
    } catch (requestError) {
      if (isResponse(requestError) && requestError.response.status === 400) {
        setError((await getFieldErrors(requestError)).email);
      } else {
        toast.error(gettext('Oops. Something went wrong.'));
      }
    }
  };
  const [handleSend, isSending] = useAsyncFunction(send);

  if (isSent) {
    return (
      <AuthCard title={gettext('Check your email')}>
        <p className="mt-6 text-center text-base leading-snug text-black">
          {gettext('If an account exists for this email, we have sent you a link to set a new password.')}
        </p>
        <p className="mt-8 text-center text-base">
          <Link to={loginUrl} className="font-semibold text-brand-500">
            {gettext('Back to sign in')}
          </Link>
        </p>
      </AuthCard>
    );
  }

  return (
    <AuthCard
      title={gettext('Forgot your password?')}
      subtitle={gettext("Enter your work email and we'll send you a link to set a new password.")}
    >
      <form
        className="mt-8 flex flex-col gap-5"
        onSubmit={(event) => {
          event.preventDefault();
          handleSend();
        }}
      >
        <TextInput
          label={gettext('Work email')}
          type="email"
          name="email"
          autoComplete="email"
          icon={<EmailIcon />}
          placeholder="name@company.com"
          value={email}
          onChange={(value) => {
            setEmail(value);
            setError(undefined);
          }}
          error={error}
        />
        <Button type="submit" variant="primary" size="lg" fullWidth loading={isSending}>
          {gettext('Send link')}
        </Button>
      </form>
      <p className="mt-8 text-center text-base">
        <Link to={loginUrl} className="font-semibold text-brand-500">
          {gettext('Back to sign in')}
        </Link>
      </p>
    </AuthCard>
  );
}

export default PasswordReset;
